<template>
  <div>
    <div class="my-3">
      <em class="font-18 color-orange fa fa-info-circle mr-2" />
      <span class="color-black font-16 font-weight-bold">
        Detalle de Visitas
      </span>
    </div>
    <div
      v-for="item in paginatedVisits"
      :key="item.visitId"
      class=" mb-2 px-3 border-bottom"
    >
      <div class="row">
        <div class="col pl-0">
          <span class="data-label">Fecha:</span>
          <p class="data">{{ item.visitDate }}</p>
        </div>
        <div class="col-3">
          <span class="data-label">Horario:</span>
          <p class="data">{{ item.durationRange }}</p>
        </div>
        <div class="col-3">
          <span class="data-label">Tipo de Visita:</span>
          <p class="data">{{ item.visitTypeName }}</p>
        </div>
        <div class="col">
          <span class="data-label">Especialista:</span>
          <p class="data">{{ item.specialistName }}</p>
        </div>
        <div class="col">
          <span class="data-label">Transportación:</span>
          <p class="data">
            {{ item.hasTransportation ? 'Sí' : 'No' }}
          </p>
        </div>
      </div>
    </div>
    <pagination
      v-if="pageCount > 1"
      :data="paginationData"
      @pagination-go-page="currentPage = $event"
    />
    <custom-result-not-found v-if="!hasVisits" />
  </div>
</template>

<script>
import CustomResultNotFound from 'custom-result-not-found';
import Pagination from 'pagination';

export default {
  name: 'VisitDetails',
  components: {
    CustomResultNotFound,
    Pagination,
  },
  props: {
    data: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  data() {
    return {
      currentPage: 1,
      itemsPerPage: 5,
    };
  },
  computed: {
    hasVisits() {
      return this.data.length > 0;
    },
    pageCount() {
      return Math.ceil(this.data.length / this.itemsPerPage);
    },
    paginatedVisits() {
      const startIndex = (this.currentPage - 1) * this.itemsPerPage;
      const endIndex = startIndex + this.itemsPerPage;
      return this.data.slice(startIndex, endIndex);
    },
    paginationData() {
      return {
        currentPage: this.currentPage,
        totalItemCount: this.data.length,
        pageCount: this.pageCount,
        count: this.itemsPerPage,
      };
    },
  },
};
</script>
